import FirstContentBox from "./FirstContentBox";

export default FirstContentBox;
